import Link from "next/link";
import { cx } from "@/lib/all";

export default function Category({ categories }) {
  return (
    <span>
      {categories.edges.length > 0 ? (
        categories.edges.map((category, index) => (
          <>
            <Link
              rel="dofollow"
              key={category?.node?.name}
              title={category?.node?.name}
              href={`/blog/category/${category?.node?.slug}`}
              className={cx(
                "text-xs font-medium tracking-wider uppercase text-purple"
              )}
            >
              {category?.node?.name}
            </Link>
            {index + 1 !== categories.edges.length ? ",\u00A0" : ""}
          </>
        ))
      ) : (
        <span className="ml-1">{categories?.edges?.node?.name}</span>
      )}
    </span>
  );
}
